const cardBackElements = document.querySelectorAll('.logos__card-back');
const cards = document.querySelectorAll('.logos__item');

if (cardBackElements.length > 0) {
    cardBackElements.forEach(card => {
        const height = card.offsetHeight;
        const parentItem = card.closest('.logos__item');

        if (parentItem) {
            parentItem.style.setProperty('--card-back-height', height + 'px');
        }
    });
}

if (window.innerWidth < 992) {
    cards.forEach(card => {
        const front = card.querySelector('.logos__card-front');

        front.addEventListener('click', () => {
            cards.forEach(otherCard => {
                if (otherCard !== card) {
                    otherCard.classList.remove('is-active');
                }
            });

            card.classList.toggle('is-active');
        });
    });
}
